import React from 'react';
import { Box } from '@material-ui/core';
import { Header, HeaderLabel } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { MyEntityContextMenu } from './MyEntityContextMenu';

export const CustomEntityHeader = () => {
  const { entity } = useEntity();

  const title = entity.metadata.title ?? entity.metadata.name;
  // const subtitle = entity.metadata.description;
  const spec = entity.spec as { owner?: string; lifecycle?: string };

  return (
    <div style={{borderLeft: '0.1px solid #535353'}}>

    <Header
      title={title}
      // subtitle={subtitle}
    >
      <HeaderLabel label="Owner" value={sentenceCase(spec?.owner) ?? '—'} />
      <HeaderLabel label="Lifecycle" value={sentenceCase(spec?.lifecycle) ?? '—'} />

      <Box ml="auto">
        <MyEntityContextMenu />
      </Box>
    </Header>
  </div>
  );
};

// Helper to convert a string to sentence case
function sentenceCase(str: string | undefined): string | undefined {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}